import { deriveSectionFromRoute } from './deriveSectionFromRoute'

const PUBLISH_TABS = new Set(['queue', 'drafts', 'sent', 'approvals'])
const CREATE_IDEA_VIEWS = new Set(['board', 'gallery', 'list', 'ideas'])

/**
 * Derives the view slug for a saved view from the current route. Returns
 * `null` for sections where no view is meaningful (currently insights).
 */
export function deriveViewFromRoute(
  pathname: string,
  searchParams: URLSearchParams,
): string | null {
  const section = deriveSectionFromRoute(pathname)

  if (section === 'publish') {
    if (/\/calendar(\/|$)/.test(pathname)) {
      return 'calendar'
    }
    const tab = searchParams.get('tab')
    if (tab && PUBLISH_TABS.has(tab)) {
      return tab
    }
    return 'queue'
  }

  if (section === 'community') {
    if (/\/posts(\/|$)/.test(pathname)) {
      return 'posts'
    }
    return 'comments'
  }

  if (section === 'create') {
    if (/^\/create\/ideas(\/|$)/.test(pathname)) {
      const view = searchParams.get('view')
      if (view && CREATE_IDEA_VIEWS.has(view)) {
        return view
      }
      return 'ideas'
    }
    if (/^\/create\/feeds(\/|$)/.test(pathname)) return 'feeds'
    if (/^\/create\/templates(\/|$)/.test(pathname)) return 'templates'
    if (/^\/create\/tools(\/|$)/.test(pathname)) return 'tools'
    return 'ideas'
  }

  return null
}
